import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import './index.css'
import Kreuz from '../components/kreuz'
import Wrapper from '../components/wrapper'
import Countdown from '../components/countdown'

const Middle = styled.nav`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 25px;
  justify-content: space-between;
`

const FooterText = styled.div`
  text-align: center;
  font-size: 0.8em;
  opacity: ${props => (props.faded ? 0.3 : 1)};
`

const NameText = styled(Link)`
  color: #ff4439;
  text-decoration: none !important;
  :hover {
    opacity: 0.7;
  }
`

const Anchor = styled.a`
  color: rgb(69, 149, 255);
  text-decoration: none;
  :hover {
    color: rgb(108, 171, 255);
  }
`

const Header = () => (
  <Wrapper>
    <Middle>
      <Link to="/">
        <Kreuz />
      </Link>
      <NameText to="/">Kreuz Apps</NameText>
    </Middle>
  </Wrapper>
)
const Footer = () => (
  <Wrapper>
    <FooterText>
      Copyright Kreuz {new Date().getFullYear()}
      {' – '}
      <Anchor href="https://timo.sh">Timo Lins</Anchor>
    </FooterText>
    <FooterText faded>
      Noch <Countdown /> Tage Zivildienst
    </FooterText>
  </Wrapper>
)

const TemplateWrapper = ({children}) => (
  <div>
    <Helmet
      title="Kreuz Apps"
      meta={[
        // {name: 'description', content: 'Sample'},
        {
          name: 'keywords',
          content: 'Rotes Kreuz, Dienstplan, RK, Niederösterreich, 144, Apps'
        }
      ]}
    />

    <Header />
    <Wrapper>{children()}</Wrapper>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js